const data = {
	"width": 24,
	"height": 24,
	"hidden": true,
	"body": "<path d=\"M21.706 5.292l-2.999-2.999A.996.996 0 0 0 18 2H6a.997.997 0 0 0-.707.293L2.294 5.292A.996.996 0 0 0 2 6v13c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6a.994.994 0 0 0-.294-.708zM6.414 4h11.172l1 1H5.414l1-1zM12 18l-5-5h3v-3h4v3h3l-5 5z\" fill=\"currentColor\"/>"
};
exports.__esModule = true;
exports.default = data;
